import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const updateDirectSettingValue = async (directId, key, value) => {
  return axios.patch(
    `/api/directs/${directId}/settings/${key}`,
    JSON.stringify({ value: String(value) })
  );
};

export const useUpdateDirectSettingValue = (directId, key) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (value) => updateDirectSettingValue(directId, key, value),
    onSuccess: () => {
      enqueueSnackbar('Setting was successfully updated', { variant: 'success' });
    },
    onError: (error) => {
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
